<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolProblematicPrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      detailInlineButtonType="showAttachmentEntity"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="search"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   showName
                                                   customLabel="查看PR"
                                                   @click="getPrPage(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolProblematicPr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="closeProblem"
                                    >关闭问题
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolProblematicPr'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showReplyDialog()"
                                    >重新回复
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="重新回复" :visible.sync="dialogFeedbackVisible">
            <el-form>
                <el-form-item label="描述">
                    <el-input type="textarea" v-model="feedbackDescription" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="附件">
                    <multi-attachment class="w-100"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds">
                    </multi-attachment>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFeedbackVisible = false">取 消</el-button>
                <el-button type="primary" @click="replyProblem">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-31 09:21:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import moment from 'moment';
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MultiAttachment from "../../../components/echarts-part/stuff/MultiAttachment.vue";

export default {
    name: "sithMesStoolHandleProblematicPrListView",
    components: {MultiAttachment, MiniButton},
    mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            feedbackDescription: '',
            dialogFeedbackVisible: false,
            user: [],
            hopeFeedbackDate: '',
            attachmentIds: '',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    methods: {
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        getPrPage(row) {
            this.$router.push({name: 'sithMesStoolOpenPrList', params: {prId: row.prId}});
        },
        closeProblem() {

            this.dialogConfirmDateVisible = false;
            let entityModel = this.$store.state[this.modelName];
            const items = entityModel.rows.filter(row => entityModel.checkedItems.indexOf(row.id) !== -1);
            let arr = items.map(row => {
                row.finishFlag = 'finished';
                row.closedPerson = this.user.loginName;
                row.closedTime = moment().format('YYYY-MM-DD HH:mm:ss');
                return row;
            });
            let closeUrl = this.$store.state.sithMesStoolProblematicPr.baseModuleUrl + "/sithMesStoolProblematicPr/closeProblem";
            this.$_emApiMixin_post(closeUrl, arr).then(response => {
                commonViewsUtil.showSuccess(this, "操作成功！");
                this.$refs['emListFilter'].doQuery();
            });
        },
        showReplyDialog() {
            this.dialogFeedbackVisible = true;
            this.reply = [];
            var url = this.$store.state.emAclUser.baseModuleUrl + "/emAclUser";
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    data.forEach((item) => {
                        this.reply.push({value: item['loginName'], label: item['name'] + '-' + item['loginName']});
                    });
                });
        },
        replyProblem() {
            this.dialogFeedbackVisible = false;
            let row = this.$store.state[this.modelName].entity;
            row.problemDescription = this.feedbackDescription;
            row.problemReport = this.attachmentIds;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolProblematicPr/feedback";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "通知完成！");
                    this.$refs["emListFilter"].doQuery();
                })
        },
        getDetailInlineButtonType(row) {
            if (row.problemReport) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';

        },

    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName;
        },
        $_rowMaterialKey() {
            return 'matCode';
        }
    },
    created() {
        this.$store.dispatch("api/get", {
            url: this.$store.state.emAclUser.baseModuleUrl + "/emAclUser/currentUser"
        }, {
            root: true
        })
            .then(data => {
                this.user = data;
            })
    },
    mounted() {
        let prId = this.$route.query.prId;
        if (prId) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('prIdFilter', prId);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
